import * as React from 'react';
import {
  ContentGrid,
  // ContentGridInnerContainer,
} from 'components/global-layout';
import { PurchasedCoupons } from '../components/gift-coupons/purchased-coupons';
import { Ecoupon } from '../components/gift-coupons/e-coupon';
import { PageHeading } from 'components/page-heading';
import { CheckoutResultTarget } from '../components/account/checkout-result-target';
import { useTitle } from '../common/hooks/use-title';
import { getConfig } from 'app/env';
import { styled } from 'naan/stitches.config';
import { Text } from 'naan/primitives/text';
import { VSpacer } from 'naan/primitives/spacer';
// import { CouponCodeForm } from 'components/gift-coupons/coupon-code-form';
import { LargeGap } from 'components/ds/common/spacers';
import { AppFactory } from 'app/app-factory';
// import { CouponAppliedDialog } from 'components/gift-coupons/coupon-applied-dialog';

import { CouponCodeFormWidget } from 'components/gift-coupons/coupon-code-form-widget';
import __ from 'core/lib/localization';

const CouponsWrapper = styled('div', {
  paddingTop: '56px',
  '& > * + * ': {
    marginTop: '24px',
    '@medium': {
      marginTop: '0px',
    },
  },
  '@medium': {
    display: 'grid',
    gridTemplateColumns: 'repeat(12,1fr)',
    columnGap: '24px',
    '& > div:first-child': {
      gridColumn: '3 / span 4',
    },
    '& > div': {
      gridColumn: 'span 4',
    },
  },
});

const MiddleColumn = styled('section', {
  gridColumn: '1/-1',
});

const MobileHeaderSpacer = styled('div', {
  height: '24px',
  '@large': {
    height: '0',
  },
});

const PurchasePrompt = styled('p', {
  '@large': {
    maxWidth: `${(100 / 12) * 8}%`,
  },
});

const CopyWrapper = styled('div', {
  $$spaceBetween: '$space$8',
  padding: 24,
  backgroundColor: '$colors$gray-25',
  borderRadius: 12,
  '& h3': {
    textStyle: 'small-heading',
    marginBottom: '$space$4',
  },
  '& a': {
    color: '$textPrimary',
    textDecoration: 'underline',
  },
  '& > div + div': {
    paddingTop: '$$spaceBetween',
  },

  '@large': {
    $$spaceBetween: 0,
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 24,
  },
});

export const GiftCouponsForm = () => {
  return (
    <>
      <CouponCodeFormWidget
        title={'Redeem a gift coupon'}
        placeholder={__('Coupon code', 'common.couponCode')}
        buttonLabel={__('Redeem', 'common.redeem')}
      />
      <LargeGap />
    </>
  );
};

export const GiftCouponsScreen = () => {
  useTitle(__('Gift coupons', 'coupons.giftCoupons'));

  const { userManager } = AppFactory.root;
  const accountData = userManager.accountData;
  const { purchasedCoupons, giftPlans = [] } = accountData;

  return (
    <ContentGrid>
      <MiddleColumn>
        <PageHeading
          title={__('Gift coupons', 'coupons.giftCoupons')}
          size="large"
        />
        <MobileHeaderSpacer />
        <GiftCouponsForm />

        <PurchasedCoupons coupons={purchasedCoupons} />
        <Text textStyle="medium-heading">Purchase a gift coupon</Text>
        <VSpacer size={4} />
        <PurchasePrompt>
          Know someone who&rsquo;s studying Spanish at the intermediate level?
          Help them get fluent faster with a Lupa e-coupon.
        </PurchasePrompt>
        <CouponsWrapper className="coupons">
          {giftPlans.map((plan: any) => (
            <Ecoupon plan={plan} key={plan.slug} />
          ))}
        </CouponsWrapper>
        <LargeGap />
        <CopyWrapper>
          <div>
            <h3>How do gift coupons work?</h3>
            <p>
              After you buy a gift coupon you will receive an email with the
              coupon code and instructions of how to redeem. The coupon code
              will also be listed at the top of this page, and you'll be able to
              see when it is redeemed, and by whom.
            </p>
            <p>
              The recipient will create their account and redeem the coupon on
              this website.
            </p>
          </div>
          <div>
            <h3>Any questions?</h3>
            <p>
              We're here to help,{' '}
              <a
                href={getConfig('website.urls.support')}
                target="_blank"
                rel="noreferrer noopener"
              >
                visit our help center
              </a>
              .
            </p>
          </div>
        </CopyWrapper>
        <LargeGap />
        <CheckoutResultTarget />
      </MiddleColumn>
    </ContentGrid>
  );
};
